module.exports = __webpack_public_path__ + "static/img/12061D_R_2_3_4_20180406_LC.29437e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/12061D_R_2_3_4_20180406_LC.png
// module id = j63q
// module chunks = 0